import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Row, Col, Card } from 'antd';
import { Tab, Tabs, Autocomplete, TextField, Checkbox, Container, Button, Paper, Grid, Stack, Typography, TableContainer, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import CustomButton from '../Reusable/CustomButton';
import { BASE_URL } from '../../App'
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import UndoTwoToneIcon from '@mui/icons-material/UndoTwoTone';
import Swal from 'sweetalert2';
import { Block as BlockIcon } from '@mui/icons-material';
import Chip from '@mui/material/Chip';
import {Backdrop, CircularProgress, } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const DynamicReport = () => {
  const [tabs, setTabs] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [rptgroup, setrptgroup] = useState([]);
  const [rptname, setrptname] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedname, setselectedname] = useState('');
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [openCard, setOpenCard] = useState(true);
  const [loading, setloading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const login_id = localStorage.getItem("LOGIN_ID");
  const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");
  const usertype = localStorage.getItem("usertype");
  const handleAutocompleteChange = (event, newValue) => {
    setSelectedValue(newValue);
    setTabs([]);
  }; 
  const handleAutocompleteChangebranch = (event, newValue) => {
    setSelectedBranches(newValue);
  };
  const handleChangerptname = (event, newValue) => {
    setselectedname(newValue);
    setTabs([]);
  };
  // Report Group 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =  await axios.post(BASE_URL + '/getrptgroup', {
          login_id: login_id,
          group: usertype,
        });
        const responseData = response.data;
        const Reportgrp = responseData.getrptgroup || [];
        setrptgroup(Reportgrp);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  // ReportName 
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =  await axios.post(BASE_URL + '/getrptname',  {
          login_id: login_id,
          group: usertype,
          rptgroup: selectedValue.RPTGROUP
        });
        const responseData = response.data;
        const Reportname = responseData.getrptname || [];
        setrptname(Reportname);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (selectedValue) {
      fetchData();
    }
  }, [selectedValue]);

  // Dynamic filters
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await axios.post(BASE_URL + '/getdynamicreportfilter');
  //       const data = response.data;
  //       setTabs(data.getdynamicreportfilter || []);
  //       // Initialize selectedOptions state with an object where each key represents tab.DISPLAY_DESC and its value is an array of selected options
  //       const selectedOptionsObject = {};
  //       data.getdynamicreportfilter.forEach(tab => {
  //         selectedOptionsObject[tab.DISPLAY_DESC] = [];
  //       });
  //       setSelectedOptions(selectedOptionsObject);
  //     } catch (error) {
  //       console.error('Error fetching tabs data:', error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const fetchOptions = async () => {
    try {
      setloading(true);
      const prevTabSelectedOptions = selectedOptions[tabs[currentTab - 1]?.DISPLAY_DESC] || [];
      // const response = await axios.post(`http://192.168.1.104/grssuite/public/api/${tabs[currentTab]?.FIELDNAME}`, {
      const response = await axios.post(BASE_URL+'/'+tabs[currentTab]?.FIELDNAME, {
        selectedOptions: selectedOptions,login_id:login_id,usertype:usertype,branch_code:BRANCH_CODE,report_code:selectedname.RPTCODE,
        display_name:tabs[currentTab]?.DISPLAY_DESC 
      });

      const data = response.data;
      setOptions(data.list || []);
      if(response.status===200){
        setloading(false);
        if(response.data.status_code==="400"){
          Swal.fire({
            icon: "info",
            text: response.data.message
        });
        }
      }
    } catch (error) {
      console.error('Error fetching options data:', error);
    }
    finally{
      setloading(false);
    }
  };

  useEffect(() => {
    if (tabs.length > 0) {
      fetchOptions();
    }
  }, [currentTab,tabs]);

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  // const handleCheckboxChange = (event, value) => {
  //   const selectValue = Array.isArray(value) ? value[value.length - 1] : value;
  //   const currentOptions = selectedOptions[tabs[currentTab]?.DISPLAY_DESC] || [];
  //   setSelectedOptions(prevSelectedOptions => {
  //     const updatedOptions = {
  //       ...prevSelectedOptions,
  //       [tabs[currentTab]?.DISPLAY_DESC]: event.target.checked
  //         ? [...new Set([...currentOptions, selectValue])]
  //         : currentOptions.filter(option => option !== selectValue)
  //     };
  //     return updatedOptions;
  //   });
  // };
  // const handleCheckboxChange = (event, value) => {
  //   setSelectedOptions(prevSelectedOptions => {
  //     const currentOptions = prevSelectedOptions[tabs[currentTab]?.DISPLAY_DESC] || [];
  
  //     // Ensure option is added only if not already selected
  //     const updatedOptions = value.filter(
  //       (option, index, self) => index === self.findIndex((o) => o.value === option.value)
  //     );
  
  //     return {
  //       ...prevSelectedOptions,
  //       [tabs[currentTab]?.DISPLAY_DESC]: updatedOptions
  //     };
  //   });
  // };
  const handleCheckboxChange = (event, value) => {
    setSelectedOptions(prevSelectedOptions => {
      const currentOptions = prevSelectedOptions[tabs[currentTab]?.DISPLAY_DESC] || [];
  
      // Ensure option is added only if not already selected
      const updatedOptions = value.filter(
        (option, index, self) => index === self.findIndex((o) => o.value === option.value)
      );
  
      // Construct the updated selection object
      let newSelectedOptions = {
        ...prevSelectedOptions,
        [tabs[currentTab]?.DISPLAY_DESC]: updatedOptions
      };
  
      // Remove empty selections (keys with empty arrays)
      Object.keys(newSelectedOptions).forEach(key => {
        if (Array.isArray(newSelectedOptions[key]) && newSelectedOptions[key].length === 0) {
          delete newSelectedOptions[key];
        }
      });
  
      return newSelectedOptions;
    });
  };
  
  
  
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, settoDate] = useState(dayjs());
  const handleDateChange = (newDate) => {
    setFromDate(newDate); // Update the state with the selected date
  };
  const handletoDateChange = (newDate) => {
    settoDate(newDate); // Update the state with the selected date
  };

  const handleSubmit = async () => {
    try {
      setloading(true);
      const requestData = {
        report_code: selectedname.RPTCODE,
        selectedOptions: selectedOptions,
        fromdate: fromDate.format('YYYY-MM-DD'),
        todate: toDate.format('YYYY-MM-DD'),
        tableData: {},
        login_id:login_id
      };
  
      for (const tab of tabs) {
        const selectedData = selectedOptions[tab.DISPLAY_DESC] || [];
        const data = Array.isArray(selectedData) ? selectedData : [selectedData];
        requestData.tableData[tab.DISPLAY_DESC] = data;
      }
  
      const response = await axios.post(BASE_URL + '/getreportbasedondataa', requestData);
      
      if (response.data.status_code==="200") {
//         if (response.outputdata.length > 1000) {
//   downloadCSVFile("warranty_registrations.csv", response.outputdata);
// } else {
//    setTableData(response.data.outputdata);
//         setShowTable(true);
//         setOpenCard(false);
//         setTabs([]);
// }
const output = response.data.outputdata;

      if (output.length > 1000) {
        downloadCSVFile("warranty_registrations.csv", output);
      } else {
        setTableData(output);
        setShowTable(true);
        setOpenCard(false);
        setTabs([]);
      }
       
      } else if(response.data.status_code==="400") {
      //  alert('1');
        Swal.fire({
          icon: "info",
          text: response.data.message||'No Data found !'
      });
      }
      else {
        //alert('2');
        setTableData([]);
        Swal.fire({
          icon: "info",
          text: 'No Data found !'
      });
      }
    } catch (error) {
      //alert('4');
      Swal.fire({
        icon: "info",
        text: 'No Data found !'
    });
      console.error('Error submitting data:', error);
    } finally {
      setloading(false); // This will execute no matter what
    }
  };
//   function convertToCSV(data) {
//   const replacer = (key, value) => value === null ? '' : value;
//   const header = Object.keys(data[0] || {}); // handle empty data safely

//   const csv = [
//     header.join(','), // column headers
//     ...data.map(row =>
//       header.map(field => JSON.stringify(String(row[field] || '').replace(/\u00a0/g, ' '), replacer)).join(',')
//     )
//   ].join('\r\n');

//   return csv;
// }

// function downloadCSVFile(filename, data) {
//   const csv = convertToCSV(data);
//   const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

//   const link = document.createElement("a");
//   const url = URL.createObjectURL(blob);

//   link.setAttribute("href", url);
//   link.setAttribute("download", filename);
//   link.style.visibility = 'hidden';

//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }
function convertToCSV(data) {
  if (!data || !data.length) return '';

  const headers = Object.keys(data[0]);

  const escapeCSVValue = (value) => {
    if (value == null || value === '') return '';
    
    let str = String(value).trim();
    
    // Escape quotes and wrap in quotes if contains commas, quotes, or newlines
    if (str.includes('"') || str.includes(',') || str.includes('\n') || str.includes('\r')) {
      str = '"' + str.replace(/"/g, '""') + '"';
    }
    
    return str;
  };

  const csvRows = [
    headers.map(escapeCSVValue).join(','), // header row
    ...data.map(row =>
      headers.map(field => {
        // Ensure every field is processed, even if missing from the row
        const value = Object.prototype.hasOwnProperty.call(row, field) ? row[field] : '';
        return escapeCSVValue(value);
      }).join(',')
    )
  ];

  return csvRows.join('\r\n');
}




function downloadCSVFile(filename, data) {
  const csv = convertToCSV(data);
  // Add BOM so Excel reads UTF-8 correctly
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}


  const handleProcess = async () => {
    try {
      setloading(true);
      if(!selectedname){
        setloading(false);
        Swal.fire({
          icon: "info",
          text: 'Please Select Report Name !'
      });
      }
      const response =  await axios.post(BASE_URL + '/getdynamicreportfilter',{
        reportcode:selectedname.RPTCODE
      });
      const data = response.data;
      setTabs(data.getdynamicreportfilter || []);
      setSelectedOptions(Object.fromEntries(data.getdynamicreportfilter.map((tab, index) => [index, []])));
    } catch (error) {
      console.error('Error fetching tabs data:', error);
    }
    finally {
      setloading(false); // This will execute no matter what
    }
  };


  
  const handleExportExcelClick = () => {
    if (tableData.length === 0) {
        Swal.fire({
            icon: "info",
            text: 'No Data Available For export!'
        });
        return;
    }
    Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to download the Excel file?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, download it!',
        cancelButtonText: 'No, cancel!',
        reverseButtons: true
    }).then((result) => {
        if (result.isConfirmed) {
          setOpenCard(true);

            const ExcelJS = require('exceljs');
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            // Define columns based on tableData structure
            worksheet.columns = Object.keys(tableData[0]).map(key => ({ header: key, key }));

            // Add data to the worksheet
            tableData.forEach(data => worksheet.addRow(data));

            // Set header row styles (e.g., background color)
            const headerRow = worksheet.getRow(1);
            headerRow.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: '1976d2' } // Red color as an example; customize as needed
                };
            });

            // Autofilter for all columns
            worksheet.autoFilter = {
                from: 'A1',
                to: 'I1'
            };

            // Generate Excel file and initiate download
            setTimeout(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                   link.download = `${selectedname.RPTNAME}.xlsx`;
                    link.click();
                    setOpenCard(false);
                });
            }, 1000);
        }
    });
};

const handleCloseCard = () => {
  setOpenCard(true);
  setShowTable(false); 
  setTableData([]);// Show the table when the card is closed
  setTabs([]);
};
const styles = {
  noDataContainer: {
    display: 'flex',
    flexDirection: 'column', // Stack the icon and text vertically
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px', // Adjust based on your needs
    backgroundColor: '#f4f4f4',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  noDataIcon: {
    fontSize: '48px', // Adjust size as needed
    color: '#1976d2', // Use the same color as the table header for consistency
    marginBottom: '10px', // Space between icon and text
  },
  noDataText: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1976d2',
    padding: '10px',
    textAlign: 'center',
  },
};
  return (
    <div>
      <Container>
        <br />
        {openCard && ( 
          <>
      {/* <Card style={{
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
            }}>
              <center><h4>Dynamic Report</h4> </center>
 
              </Card> */}
              {/* <br /> */}
              <Card
  style={{
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    padding: '8px', // Minimized padding
   // maxWidth: '800px', // Compact width
    margin: 'auto', // Center the card
  }}
>
  <Grid container spacing={1} alignItems="center">
    {/* Report Group */}
    <Grid item xs={12} sm={6}>
      <Typography variant="body2" sx={{ fontWeight: 'bold',marginBottom:'15px' }}>
        Report Group
      </Typography>
      <Autocomplete
        freeSolo
        disableClearable
        options={rptgroup}
        getOptionLabel={(option) => option.RPTGROUPNAME}
        getOptionValue={(option) => option.RPTGROUP}
        value={selectedValue || undefined}
        onChange={handleAutocompleteChange}
        renderInput={(params) => (
          <TextField {...params} size="small" label="Select" />
        )}
      />
    </Grid>

    {/* Report Name */}
    <Grid item xs={12} sm={6}>
      <Typography variant="body2" sx={{ fontWeight: 'bold',marginBottom:'15px'  }}>
        Report Name
      </Typography>
      <Autocomplete
        freeSolo
        disableClearable
        options={rptname}
        getOptionLabel={(option) => option.RPTNAME}
        getOptionValue={(option) => option.RPTCODE}
        value={selectedname || undefined}
        onChange={handleChangerptname}
        renderInput={(params) => (
          <TextField {...params} size="small" label="Select" />
        )}
      />
    </Grid>
<br/>
    {/* From Date */}
    <Grid item xs={12} sm={3}>
  <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: '6px' }}>
    From Date
  </Typography>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <MobileDatePicker
      defaultValue={fromDate}
      onChange={handleDateChange}
      format="DD-MMM-YYYY"
      slotProps={{ 
        textField: { 
          size: 'small', 
          sx: { width: '250px', height: '36px' } // Uniform size
        } 
      }}
    />
  </LocalizationProvider>
</Grid>

{/* To Date */}
<Grid item xs={12} sm={3}>
  <Typography variant="body2" sx={{ fontWeight: 'bold', marginBottom: '6px' }}>
    To Date
  </Typography>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <MobileDatePicker
      defaultValue={toDate}
      onChange={handletoDateChange}
      format="DD-MMM-YYYY"
      slotProps={{ 
        textField: { 
          size: 'small', 
          sx: { width: '250px', height: '36px' } // Uniform size
        } 
      }}
    />
  </LocalizationProvider>
</Grid>

{/* Buttons */}


<Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '30px' }}>
  <CustomButton
    label="Process"
    onClick={handleProcess}
    variant="contained"
    size="small"
    width="250px"
    height="40px"
    borderRadius="6px"
    type="submit"
    sx={{ backgroundColor: '#28a745', color: '#fff', '&:hover': { backgroundColor: '#218838' } }} // Green theme
    startIcon={<PlayArrowIcon />} // Play icon for process
  />
  <CustomButton
    label="Execute"
    variant="contained"
    size="small"
    width="250px"
    height="40px"
    borderRadius="6px"
    type="submit"
    onClick={handleSubmit}
    sx={{ backgroundColor: '#ff9800', color: '#fff', '&:hover': { backgroundColor: '#f57c00' } }} // Orange theme
    startIcon={<CheckCircleIcon />} // Check-circle icon for execute
  />
</Grid>


  </Grid>
</Card>

</>
)}
      </Container>
      <Container>
        <br />
       
        {openCard && ( 
          <>
        {tabs.length > 0 && (
          <Tabs value={currentTab} onChange={handleChange}>
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.DISPLAY_DESC} />
            ))}
          </Tabs>
        )}
        <br />

        {tabs.length > 0 && ( 
        // <Autocomplete
        //   multiple
        //   disableCloseOnSelect
        //   options={options.map(option => ({ label: option.name, value: option.code }))}
        //   getOptionLabel={(option) => option.label}
        //   onChange={handleCheckboxChange}
        //   value={selectedOptions[tabs[currentTab]?.DISPLAY_DESC] || []}
        //   renderOption={(props, option, { selected }) => (
        //     <li {...props}>
        //       <Checkbox
        //         checked={selected}
        //         value={option.value}
        //       />
        //       {option.label}
        //     </li>
        //   )}
        //   style={{ width: 350 }}
        //   renderInput={(params) => (
        //     <TextField {...params} label={tabs[currentTab]?.DISPLAY_DESC ? `Select ${tabs[currentTab].DISPLAY_DESC}` : "Select"} />
        //   )}   
        // />
        <Autocomplete
        multiple
        disableCloseOnSelect
        options={options.map(option => ({ label: option.name, value: option.code }))}
        getOptionLabel={(option) => option.label}
        onChange={handleCheckboxChange}
        value={selectedOptions[tabs[currentTab]?.DISPLAY_DESC] || []}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip key={option.value} label={option.label} {...getTagProps({ index })} />
          ))
        }
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox checked={selected} />
            {option.label}
          </li>
        )}
        style={{ width: 350 }}
        renderInput={(params) => (
          <TextField {...params} label={tabs[currentTab]?.DISPLAY_DESC || "Select"} />
        )}
      />
      

      )}
      </>
)}
 </Container>
        {/* <br /> */}
        {/* <Button variant="contained" color="primary" onClick={handleSubmit}>
          Submit
        </Button> */}
        {/* <br /> */}
        {showTable && ( 

<Card style={{
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
            }}>

<div className='row'>
                        <div className='col-md-2'>
                        <Button size="small" fullWidth variant="contained" onClick={() => handleCloseCard()} endIcon={<UndoTwoToneIcon />}  ><b>Back</b></Button>
                        </div>
                        <div className='col-md-2'>
   
    
</div>
<div className='col-md-4'>
   <h3 style={{color:'#1976d2' ,textAlign:'center'}}>Dynamic Report</h3>
    
</div>

<div className='col-md-2'>
  
    
</div>
<div className='col-md-2'>
<Button size="small" fullWidth variant="contained" onClick={() => handleExportExcelClick()} endIcon={<DescriptionTwoToneIcon />}  ><b>Download Excel</b></Button> 
</div>

                        
                    </div>

                </Card>
        )}
        
         {/* {showTable && ( 
        <TableContainer >
          <Table>
          <TableHead style={{ height: '30px' }}> 
              <TableRow>
                {tableData.length > 0 && Object.keys(tableData[0]).map((key, index) => (
                  <TableCell key={index} style={{ backgroundColor: '#1976d2' }}>{key}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => (
                <TableRow key={index}>
                  {Object.values(row).map((value, index) => (
                    <TableCell key={index}>{value}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        )} */}
<br />
{showTable && (
  tableData.length > 0 ? (
    <TableContainer style={{ maxHeight: '500px', overflow: 'auto' }} >
      <Table stickyHeader>
        <TableHead style={{ height: '30px' }}>
          <TableRow>
            {Object.keys(tableData[0]).map((key, index) => (
              <TableCell key={index} style={{ backgroundColor: '#1976d2' }}>{key}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row, index) => (
            <TableRow key={index}>
              {Object.values(row).map((value, index) => (
                <TableCell key={index}>{value}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <div style={styles.noDataContainer}>
      <BlockIcon style={styles.noDataIcon} />
      <div style={styles.noDataText}>No data available</div>
    </div>
  )
)}
     <div>
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
          </div>
    </div>
    
  );
};

export default DynamicReport;
